module.exports = __webpack_public_path__ + "static/media/400031_01.3caea84f.png";